@if(data.action === 'Status') {
    <div class="p-3">
        <h1 mat-dialog-title>{{ data.activating ? 'Activate' : 'Deactivate' }} Member</h1>
        <div mat-dialog-content class="mt-2">
            <p>Are you sure you want to {{ data.activating ? 'activate' : 'deactivate' }} this member?</p>
        </div>
        <div class="mt-4 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                Cancel
            </button>
            @if(data.activating) {
                <button mat-raised-button class="action-button" (click)="onConfirmClick()">
                    Activate
                </button>
            } @else {
                <button mat-raised-button class="warn-button" (click)="onConfirmClick()">
                    Deactivate
                </button>
            }
        </div>
    </div>
}

@if(data.action === 'Role') {
    <div class="p-3">
        <h1 mat-dialog-title>Update Member Role</h1>
        <div mat-dialog-content class="mt-2">
            <p>Please confirm that you would like to change the role of this member from<br>
                <b>{{ data.role }}</b> to <b>{{ newMemberRole }}</b>?</p>
        </div>
        <div class="mt-4 mb-2 d-flex justify-content-end">
            <button mat-raised-button class="cancel-button" (click)="onCancelClick()">
                Cancel
            </button>
            <button mat-raised-button class="action-button" (click)="onConfirmClick()">
                Submit
            </button>
        </div>
    </div>
}